import axios from "axios";
import store from "./store/store";
import router from "./router";
import _ from "lodash";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

http.defaults.headers.Authorization =
  "Bearer " + store.state.authorization.access_token;
// http.defaults.headers.common["Accept-Language"] = "it";

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

if (localStorage.getItem("token")) {
  http.defaults.headers["Authorization"] =
    "Bearer " + localStorage.getItem("token");
  http.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("token");
}

http.interceptors.response.use(undefined, err => {
  let originalRequest = err.response.config;
  const responseStatusCode = _.get(err, "response.status");
  if (responseStatusCode === 401) {
    if (_.get(err, "response.data.meta.expiredToken", false)) {
      const retryOriginalRequest = new Promise(resolve => {
        subscribers.push(accessToken => {
          originalRequest.headers.Authorization = "Bearer " + accessToken;
          return resolve(http(originalRequest));
        });
      });

      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;
        http
          .get(
            "/api/v1/campaigns/" + store.state.campaign.id + "/users/refresh"
          )
          .then(response => {
            isAlreadyFetchingAccessToken = false;
            store.state.authorization.access_token = response.data.data.token;
            localStorage.setItem("token", response.data.data.token);
            http.defaults.headers.common["Authorization"] =
              "Bearer " + store.state.authorization.token;
            subscribers.forEach(callback => callback(response.data.data.token));
            subscribers = [];
          })
          .catch(err => {
            store.dispatch("logout");
          });
      }

      return retryOriginalRequest;
    } else {
      if (router.currentRoute.name !== "login") {
        store.dispatch("logout");
        router.push("/");
      }
      throw err;
    }
  } else if (responseStatusCode === 403) {
    if (
      _.get(err, "response.data.meta.userLegalRequirementsNotSatisfied", false)
    ) {
      store.state.unavailableUserState = true;
      router.replace("/agreements");
      throw err;
    } else if (_.get(err, "response.data.meta.incompleteUserProfile", false)) {
      store.state.unavailableUserState = true;
      store.commit(
        "updateMissingProfileFields",
        _.get(err, "response.data.data.missing_fields", [])
      );
      router.replace("/complete-profile");
      throw err;
    } else if (_.get(err, "response.data.meta.pendingConfirmation", false)) {
      store.state.unavailableUserState = true;
      store.commit(
        "updatePendingConfirmation",
        _.get(err, "response.data.data.pending_confirmation", [])
      );
      router.replace("/complete-profile");
    } else {
      throw err;
    }
  } else {
    throw err;
  }
});

export default http;
